// extracted by mini-css-extract-plugin
module.exports = {"passwordResetWrapper":"UserPasswordReset_passwordResetWrapper__2BTRe","passwordText":"UserPasswordReset_passwordText__2d2gA"};